/** The search box and pager over a `usePagedSearch()` state (labels via `common.pager`). */
import { TablePagination, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { PAGE_SIZES, type PagedSearch } from './usePagedSearch';
import { FIELD_WIDTH } from '@/theme';

export function SearchField({ paged, label }: { paged: PagedSearch; label: string }) {
  return (
    <TextField
      size="small"
      fullWidth
      label={label}
      value={paged.search}
      onChange={(event) => paged.setSearch(event.target.value)}
      sx={{ mb: 2, maxWidth: FIELD_WIDTH.lg }}
    />
  );
}

export function Pager({ paged, count }: { paged: PagedSearch; count: number }) {
  const { t } = useTranslation();
  return (
    <TablePagination
      component="div"
      count={count}
      page={paged.page}
      rowsPerPage={paged.size}
      rowsPerPageOptions={PAGE_SIZES}
      onPageChange={(_, next) => paged.setPage(next)}
      onRowsPerPageChange={(event) => paged.setSize(Number(event.target.value))}
      labelRowsPerPage={t('common.pager.rowsPerPage')}
      labelDisplayedRows={({ from, to, count: total }) =>
        t('common.pager.displayedRows', { from, to, count: total })
      }
      getItemAriaLabel={(type) => t(`common.pager.pageNav.${type}`)}
    />
  );
}
